<script setup lang="ts">
import { useI18n } from 'vue-i18n'

interface Props {
  show?: boolean
}

withDefaults(defineProps<Props>(), {
  show: false
})

const { t } = useI18n()
</script>

<template>
  <transition name="fade">
    <div
      v-if="show"
      class="fixed inset-0 bg-white bg-opacity-90 z-[9999] flex items-center justify-center backdrop-blur-sm"
    >
      <div class="flex flex-col items-center gap-4">
        <!-- Spinner -->
        <div class="w-12 h-12 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin"></div>

        <!-- Loading Text -->
        <p class="text-sm font-medium text-gray-700">{{ t('loading') }}</p>
      </div>
    </div>
  </transition>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
